import { render, staticRenderFns } from "./ItemRow.vue?vue&type=template&id=11f2d088&scoped=true&"
import script from "./ItemRow.vue?vue&type=script&lang=js&"
export * from "./ItemRow.vue?vue&type=script&lang=js&"
import style0 from "./ItemRow.vue?vue&type=style&index=0&id=11f2d088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f2d088",
  null
  
)

export default component.exports